<template>
  <div class="xs-container mystery-jackpot">
    <!--BMM ?몄쬆???꾪븳 ?꾩떆 ?④? 泥섎━ ( mystery-jackpot)-->
    <!-- <section class="xs-section jackpot-section">
      <div class="jackpot-title">
        <div class="jackpot_title-inner">
          <img src="@assets/img/jackpot/mystery_jackpot.gif" alt="" />
        </div>
      </div>
      <div class="jackpot-inner">
        <ul class="jackpot-lists">
          <li class="jackpot-list first">
            <p class="jackpot-num"></p>
          </li>
          <li class="jackpot-list">
            <p class="jackpot-num"></p>
          </li>
          <li class="jackpot-list">
            <p class="jackpot-num"></p>
          </li>
        </ul>
        <ul class="jackpot-lists second">
          <li class="jackpot-list">
            <p class="jackpot-num"></p>
          </li>
          <li class="jackpot-list">
            <p class="jackpot-num"></p>
          </li>
          <li class="jackpot-list">
            <p class="jackpot-num"></p>
          </li>
        </ul>
      </div>
    </section>
    <section class="xs-section">
      <ul class="game-type">
        <li class="type-list">
          <img class="type-img" src="@assets/img/category_jackpot00.png" />
        </li>
        <li class="type-list">
          <img class="type-img" src="@assets/img/category_jackpot01.png" />
        </li>
        <li class="type-list">
          <img class="type-img" src="@assets/img/category_jackpot02.png" />
        </li>
        <li class="type-list">
          <button class="type-btn">
            <img src="@assets/img/jackpot/gametypes_btn.png" alt="" />
          </button>
        </li>
      </ul>
    </section> -->

    <div id="game_filter">
      <img
        class="swiper-button-prev swiper-btn-prev mt-0"
        slot="button-prev"
        :style="{
          width: '1.3125rem',
          height: '2.625rem',
          color: '#353854',
          top: 'auto',
          left: '0px',
          position: 'relative',
        }"
        :src="require(`@assets/img/arrow/vector_left.png`)"
      />
      <Swiper
        class="swiper"
        ref="mySwiper"
        :options="swiperOption"
        @transitionEnd="transitionEnd"
      >
        <SwiperSlide
          class="slide"
          v-for="(item, index) in machineGameTypeList"
          :key="index"
        >
          <img :src="require(`@assets/img/banner/${item.image}`)" />
        </SwiperSlide>
      </Swiper>

      <img
        class="swiper-button-next swiper-btn-next mt-0"
        slot="button-next"
        :style="{
          width: '1.3125rem',
          height: '2.625rem',
          color: '#353854',
          top: 'auto',
          left: '0px',
          right: '0px',
          position: 'relative',
        }"
        :src="require(`@assets/img/arrow/vector_right.png`)"
      />
      <div class="backdrop-effect"></div>
    </div>

    <v-card
      class="mx-auto filter-area"
      elevation="0"
      :style="{
        background:
          'linear-gradient(270deg, rgba(59, 62, 96, 0.50) 0%, rgba(30, 33, 52, 0.50) 49.92%, rgba(59, 62, 96, 0.50) 100%)',
      }"
    >
      <div class="d-flex filter-box">
        <div class="game-filter">
          <v-btn-toggle v-model="isState" mandatory>
            <v-btn class="filter-btn"
              ><v-icon class="all"></v-icon
              >{{ $t("allGames.gameStatus.all") }}</v-btn
            >
            <v-btn class="filter-btn"
              ><v-icon class="available"></v-icon
              >{{ $t("allGames.gameStatus.available") }}</v-btn
            >
            <v-btn class="filter-btn"
              ><v-icon class="unavailable"></v-icon
              >{{ $t("allGames.gameStatus.unavailable") }}</v-btn
            >
          </v-btn-toggle>
        </div>
        <div class="game-etc">
          <v-btn
            v-if="getLoginCheck"
            class="favorite-filter"
            elevation="0"
            :disabled="disableFavorite"
            :class="this.isFavorite ? 'active' : ''"
            @click="handleFavorite()"
          >
            <v-icon></v-icon>
            {{ $t("allGames.favorites") }}</v-btn
          >
          <div class="game-total">
            <v-icon></v-icon>
            <p>{{ filterList.length }}</p>
          </div>
        </div>
      </div>
    </v-card>

    <section class="slot-allgame xs-section">
      <div class="allgame-inner">
        <div class="allgame-box">
          <div class="main-games">
            <ul class="main-game-lists">
              <li
                class="main-game-list"
                v-for="(item, index) in filterList"
                :key="index"
              >
                <div
                  class="main-game-box"
                  :class="item.state === 2 ? 'use' : ''"
                >
                  <div class="main-game-img hot" @click="handleGame(item)">
                    <div class="click-img">
                      <div class="game-img">
                        <img
                          :src="require(`@assets/img/main/${item.url}`)"
                          :alt="item.title"
                        />
                      </div>
                      <div class="game-img" v-if="item.url02 !== null">
                        <img
                          :src="require(`@assets/img/main/${item.url02}`)"
                          :alt="item.title"
                        />
                      </div>
                    </div>
                    <div class="game-state">
                      <p
                        class="state"
                        :class="[
                          {
                            disabled: item.state == 0,
                            idle: item.state == 2,
                            disuse:
                              item.state == 1 ||
                              item.state === 3 ||
                              item.state === 4,
                          },
                        ]"
                      >
                        {{ machineState(item.state) }}
                      </p>
                    </div>
                    <div class="machine-num">
                      <p class="machine-id"># {{ item.machine_number }}</p>
                    </div>
                    <div class="state-filter">
                      <div class="use-state watch" v-if="item.state == 2">
                        <div class="machine-logo">
                          <img
                            :src="
                              require(`@assets/img/main/${item.machine_url}`)
                            "
                          />
                        </div>
                        <v-btn class="watch-btn play">
                          <v-icon></v-icon>
                          <span>{{ $t("machineStatus.playNow") }}</span>
                        </v-btn>
                      </div>
                      <div class="use-state watch" v-else-if="item.state == 3">
                        <div class="machine-logo">
                          <img
                            :src="
                              require(`@assets/img/main/${item.machine_url}`)
                            "
                          />
                        </div>
                        <v-btn class="watch-btn">
                          <v-icon></v-icon>
                          <span>{{ $t("machineStatus.watching") }}</span>
                        </v-btn>
                      </div>
                      <div class="use-state" v-else-if="item.state == 4">
                        <img src="@assets/img/main/locked-icon.png" alt="" />
                        <p class="state">{{ $t("machineStatus.locked") }}</p>
                      </div>
                      <div class="use-state" v-else>
                        <img src="@assets/img/state-icon.png" alt="" />
                        <p class="state">
                          {{ $t("machineStatus.maintenance") }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="main-game-title hot">
                    <p>{{ item.title ? item.title : "-" }}</p>
                    <div class="like-icon" v-if="getLoginCheck" @click="handleLike(index)">
                      <i
                        id="heart"
                        class="heart-icon"
                        :class="item.isLike ? 'active' : ''"
                      ></i>
                    </div>
                  </div>
                  <!-- BMM ?몄쬆 ?댄썑 ??젣 寃곗젙 -->
                  <!-- <div class="main-game-img hot">
                  <div class="game-exp">
                    <p class="score">
                      <span>{{ item.number }}</span>
                    </p>
                    <p class="game-caption">{{ item.subTitle }}</p>
                    <div class="like-icon" v-if="getLoginCheck" @click="handleLike(index)">
                      <i
                        id="heart"
                        class="heart-icon"
                        :class="item.isLike ? 'active' : ''"
                      ></i>
                    </div>
                  </div>
                  <div class="click-img" @click="handleGame(index)">
                    <img
                      :src="require(`@assets/img/${item.url}`)"
                      alt="hotgame1"
                    />
                    <img
                      :src="require(`@assets/img/${item.url}`)"
                      alt="hotgame1"
                    />
                    <div class="game-state">
                      <p
                        class="state"
                        :class="[
                          {
                            ready: item.state == 1,
                            using: item.state == 2,
                            disable: item.state == 3
                          }
                        ]"
                      >
                        {{ machineState(item.state) }}
                      </p>
                    </div>
                    <div class="state-filter">
                      <img
                        v-if="item.state == 1"
                        src="@assets/img/play_btn.png"
                        alt=""
                      />
                      <div class="use-state" v-else-if="item.state == 2">
                        <img src="@assets/img/idle_icon02.png" alt="" />
                        <p class="state">?ъ슜以?..</p>
                      </div>
                      <div class="use-state" v-else>
                        <img src="@assets/img/idle_icon.png" alt="" />
                        <p class="state">?ъ슜遺덇?</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="main-game-title hot">
                  <p>{{ item.title }}</p>
                  <div class="disable-icon" @click="handleShow(index)">
                    <i
                      class="eye-icon"
                      :class="item.isShow ? 'active' : ''"
                    ></i>
                  </div>
                </div> -->
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <div>
      <v-dialog
        id="signin_modal"
        v-if="signInDialog"
        v-model="signInDialog"
        activator="parent"
        width="auto"
      >
        <SignInDialog @closeDialog="closeSignInDialog" />
      </v-dialog>
      <!-- <v-dialog
        content-class="alert"
        v-if="notifyDialog"
        v-model="notifyDialog"
        activator="parent"
        width="auto"
      >
        <AlertDialog
          @closeDialog="closeNotifyDialog"
          :message="notifyMessage"
          :isConfirm="false"
        />
      </v-dialog> -->
    </div>
  </div>
</template>

<script>
import { AuthNamespace } from "@/store/auth";
import { MachineActions, MachineNamespace } from "@/store/machine";
import { mapActions, mapGetters } from "vuex";

import SignInDialog from "@views/components/common/dialog/SignInDialog.vue";

import { HubConnectionState } from "@microsoft/signalr";

import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

import dialogMixin from "@/mixins/dialogMixin";
import machineMixin from "@/mixins/machineMixin";

const MACHINE_FILTER = {
  ALL: 0,
  AVAILABLE: 1,
  UNAVAILABLE: 2,
};

const MACHINE_STATE = {
  DISABLED: 0,
  PREPARING: 1,
  IDLE: 2,
  USING: 3,
  Locked: 4,
};

export default {
  mixins: [dialogMixin, machineMixin],
  components: {
    SignInDialog,
    Swiper,
    SwiperSlide,
  },
  props: ["gameId"],
  data() {
    return {
      // 癒몄떊 移댄뀒怨좊━ 由ъ뒪??
      machineGameTypeList: [
        { gameId: 0, title: "all", image: "banner00.png" },
        { gameId: 1, title: "DOUBLE MONEY LINK", image: "banner01.png" },
        { gameId: 2, title: "Duo Fu Duo Cai", image: "banner02.png" },
        { gameId: 3, title: "5 Dragons Ultra", image: "banner03.png" },
        { gameId: 4, title: "GLAZE", image: "banner04.png" },
        { gameId: 5, title: "Huff more Puff", image: "banner05.png" },
        { gameId: 6, title: "Coin Combo", image: "banner06.png" },
      ],
      signInDialog: false,
      // notifyDialog: false,
      playViewDialog: false,
      notifyMessage: null,
      viewTargetMachine: {},
      swiper: null,
      swiperOption: {
        slidesPerView: "auto",
        direction: "horizontal",
        effect: "coverflow", // ?④낵
        grabCursor: true, // (true???? 而ㅼ꽌濡??≪븘 ?щ씪?대뱶
        observer: true, // ?ㅼ??댄띁 ?낅뜲?댄듃
        observeParents: true, // ?ㅼ??댄띁 遺紐⑥슂?뚯쓽 蹂?붿뿉?곕씪 ?낅뜲?댄듃
        centeredSlides: true, // ?щ씪?대뱶 媛?대뜲 ?뺣젹
        centeredSlidesBounds: true,
        loop: true, //臾댄븳 諛섎났
        speed: 500, // ?띾룄 議곗젅
        coverflowEffect: {
          rotate: 0, //?щ씪?대뜑 ?뚯쟾 媛?
          stretch: 50, // ?щ씪?대뜑媛?嫄곕━(?쎌?) : ?댁닔濡??щ씪?대뜑媛 ?쒕줈 留롮씠 寃뱀묠
          depth: 300, // 源딆씠 ?④낵媛?: ?댁닔濡?硫由ъ엳???먮굦??媛뺥빐吏?
          modifier: 1, // ?④낵 諛곗닔 : ???レ옄媛믩뱾????媛믪쓣 怨깊븯湲?泥섎━?섏뿬 ?④낵瑜?媛뺥븯寃?泥섎━??
          slideShadows: true, // ?щ씪?대뜑 洹몃┝??: 3D ?④낵瑜?媛뺤“?섍린 ?꾪븳 ?뚯쟾???먮┸???④낵
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          768: {
            coverflowEffect: {
              stretch: 100,
            },
          },
        },
        on: {
          slideChange() {
            const keyframes = [
              { transform: "translate(-50%, -50%) scale(1)" },
              { transform: "translate(-50%, -50%) scale(0.95)" },
              { transform: " translate(-50%, -50%) scale(1)" },
            ];
            const options = {
              duration: 1300,
              easing: "ease-in-out",
            };
            document
              .querySelector(".backdrop-effect")
              .animate(keyframes, options);
          },
        },
      },
      selectMachine: null,
      isState: 0, // ?꾪꽣 諛뺤뒪 - [ 0: all, 1: Available, 2: Unavailable]
      isFavorite: false, // ?꾪꽣 諛뺤뒪 利먭꺼李얘린 ?좉? ?곹깭
      currentSwiperIndex: 0,
      isActive: false,
    };
  },
  computed: {
    ...mapGetters(AuthNamespace, [
      "getExternalToken",
      "getPlayerId",
      "getLoginCheck",
    ]),

    ...mapGetters(MachineNamespace, [
      "getMachineList",
      "getMachineId",
      "getMachineConnectionState",
    ]),

    // ?꾪꽣留곷맂 寃뚯엫 癒몄떊 由ъ뒪??諛섑솚 ?대깽??
    filterList() {
      let machineFilterList = [];

      switch (this.isState) {
        // All
        case MACHINE_FILTER.ALL: {
          machineFilterList = this.getMachineList;
          break;
        }

        case MACHINE_FILTER.AVAILABLE: {
          machineFilterList = this.getMachineList.filter((m) => m.state === 2);
          break;
        }

        case MACHINE_FILTER.UNAVAILABLE: {
          machineFilterList = this.getMachineList.filter((m) => m.state !== 2);
          break;
        }
      }

      // 利먭꺼李얘린 ??ぉ 寃??
      if (this.isFavorite) {
        machineFilterList = machineFilterList.filter((m) => m.isLike === true);
      }

      return machineFilterList;
    },

    machineState() {
      return (state) => {
        let result = "";
        switch (state) {
          case MACHINE_STATE.IDLE:
            // ?ъ슜媛??
            result = this.$t("machineStatus.idle");
            break;
          case MACHINE_STATE.USING:
            // ?ъ슜以?
            result = this.$t("machineStatus.occupied");
            break;
          case MACHINE_STATE.DISABLED:
            // ?ъ슜遺덇?
            result = this.$t("machineStatus.maintenance");
            break;
          case MACHINE_STATE.PREPARING:
            // ?ъ슜遺덇?
            result = this.$t("machineStatus.preparing");
            break;
          case MACHINE_STATE.Locked:
            // ?좉?
            result = this.$t("machineStatus.locked");
            break;
          default:
            break;
        }
        return result;
      };
    },

    // 利먭꺼李얘린 踰꾪듉 鍮꾪솢?깊솕 寃??
    disableFavorite() {
      const favoriteMachine = this.filterList.filter((m) => m.isLike === true);
      if (favoriteMachine.length === 0) {
        return true;
      } else {
        return false;
      }
    },
  },

  mounted() {
    // Swiper 移댄뀒怨좊━ 珥덇린??
    if (this.gameId !== undefined) {
      this.$refs.mySwiper.$swiper.slideTo(this.gameId);
      this.selectMachine = this.machineGameTypeList[this.gameId];
    } else {
      this.selectMachine = this.machineGameTypeList[0];
    }

    this.requestMachineList(this.selectMachine.gameId);
  },

  methods: {
    ...mapActions(MachineNamespace, {
      ACTION_READ_MACHINE_LIST: MachineActions.ACTION_READ_MACHINE_LIST,
      ACTION_CREATE_MACHINE_PLAYER: MachineActions.ACTION_CREATE_MACHINE_PLAYER,
      ACTION_DELETE_MACHINE_PLAYER: MachineActions.ACTION_DELETE_MACHINE_PLAYER,
      ACTION_READ_MACHINE_GAME_TYPE:
        MachineActions.ACTION_READ_MACHINE_GAME_TYPE,
    }),

    handleLike(index) {
      this.getMachineList[index].isLike = !this.getMachineList[index].isLike;
    },
    handleShow(index) {
      this.getMachineList[index].isShow = !this.getMachineList[index].isShow;
    },
    handleGame(item) {
      // 濡쒓렇???곹깭
      if (this.getLoginCheck) {
        if (this.viewTargetMachine !== item && item.state === 3) {
          this.viewTargetMachine = item;
          this.ACTION_READ_MACHINE_GAME_TYPE(item.machine_id);
          this.openPlayViewDialog();
        } else {
          const machine_id = item.machine_id;

          // ?좏깮??癒몄떊???ъ슜???뺣낫 ?깅줉
          this.createMachinePlayer(machine_id);
        }
      } else {
        this.openSignInDialog();
      }
    },
    async handleViewTargetMachineGame() {
      this.handleGame(this.viewTargetMachine);
    },
    handleFavorite() {
      this.isFavorite = !this.isFavorite;
    },

    // 癒몄떊 由ъ뒪??議고쉶 ?붿껌
    async requestMachineList(gameId) {
      await this.ACTION_READ_MACHINE_LIST({
        bFilter: false,
        gameId: gameId,
      }).then(() => {
        // 癒몄떊 由ъ뒪?멸? 議댁옱?섎뒗 寃쎌슦
        if (this.getMachineList.length > 0) {
          // 癒몄떊 Hub媛 ?곌껐??寃쎌슦
          if (this.$machineHub.hub.state === HubConnectionState.Connected) {
            // 癒몄떊 id 以묐났 ?쒓굅
            const filter_list = [
              ...new Set(
                this.getMachineList.map((m) => {
                  return m.machine_id;
                })
              ),
            ];
            // 癒몄떊 id ?곹깭 ?붿껌
            for (const id of filter_list) {
              this.$machineHub.hub.invoke("UsingStatus", id);
            }
          }
        }
      });
    },

    async createMachinePlayer(machine_id) {
      const player_id = this.getPlayerId;
      const external_token = this.getExternalToken;

      this.ACTION_CREATE_MACHINE_PLAYER({
        machine_id,
        player_id,
        external_token,
      }).then((res) => {
        // Handle case where res is undefined (network error / CORS)
        if (!res || !res.status) {
          this.notifyMessage = {
            title: this.$t("notifyMessage.title"),
            text: "머신 플레이어 생성에 실패했습니다. 네트워크 연결을 확인해주세요.",
            btnText: this.$t("button.confirm"),
          };
          this.showNotifyDialog(this.notifyMessage);
          return;
        }

        switch (res.status) {
          case 200:
            {
              this.$router.push({
                path: "game",
                query: { id: machine_id },
              });
            }
            break;
          case 401:
            if (this.getPlayerId !== undefined) {
              this.ACTION_AUTH_LOGOUT();
              this.openSignInDialog();
            }
            break;

          case 409:
            /**
             * 409 : The Player is using another machine.
             */
            this.notifyMessage = {
              title: this.$t("notifyMessage.title"),
              text: this.$t("machine.error406"),
              btnText: this.$t("button.confirm"),
            };
            this.showNotifyDialog(this.notifyMessage);
            break;
          case 406:
            console.log(res.data.detail);
            /**
             * 406 : There are no seats left.
             */
            this.notifyMessage = {
              title: this.$t("notifyMessage.title"),
              text: this.$t("machine.error409"),
              btnText: this.$t("button.confirm"),
            };
            this.showNotifyDialog(this.notifyMessage);
            break;

          default:
            this.notifyMessage = {
              title: this.$t("notifyMessage.title"),
              text: "request failed (code: " + res.status + ")",
              btnText: this.$t("button.confirm"),
            };
            this.showNotifyDialog(this.notifyMessage);
            break;
        }
      });
    },
    openSignInDialog() {
      this.signInDialog = true;
    },
    openPlayViewDialog() {
      this.playViewDialog = true;
    },
    closeSignInDialog() {
      this.signInDialog = false;
    },
    closeNotifyDialog() {
      this.setDialog("notify", false);
      // this.notifyDialog = false;
    },

    closePlayViewDialog() {
      this.playViewDialog = false;
      this.viewTargetMachine = {};
    },

    transitionEnd() {
      const swiperIndex = this.$refs.mySwiper.$swiper.realIndex;

      if (this.currentSwiperIndex === swiperIndex) {
        return;
      } else {
        this.currentSwiperIndex = swiperIndex;
      }

      this.isState = 0;
      this.isFavorite = false;

      this.selectMachine = this.machineGameTypeList[this.currentSwiperIndex];

      // 癒몄떊 由ъ뒪??議고쉶 ?붿껌
      this.requestMachineList(this.currentSwiperIndex);
    },
  },
};
</script>

